import { StyledDropdown } from '../components/dropdown'
import { on } from 'delegated-events'

const $form = document.querySelector('form.contact-form')

const fn = {
    init: () => {
        on('change', '.contact-form [name=Inquiry]', fn.handleInquiry)
    },

    handleInquiry: (e) => {
        const $form = document.querySelector('form.contact-form')
        const selectedType = e.target.value

        let newType = false

        if (selectedType === 'Resident Concern Report') {
            if (!$form.classList.contains('contact-form--silentwitness')) {
                newType = 'silentwitness'
            }
        } else {
            if ($form.classList.contains('contact-form--silentwitness')) {
                newType = 'general'
            }
        }

        if (newType !== false) {
            ajax.url($form.dataset.formChangeEndpoint)
                .query({
                    selected: selectedType,
                    type: newType,
                })
                .get()
                .text((resp) => {
                    const $newForm = document
                        .createRange()
                        .createContextualFragment(resp)
                    $form.parentNode.replaceChild($newForm, $form)

                    StyledDropdown.setup()
                })
        }
    },
}

export default {
    can: () => $form,
    run: fn.init,
}
